 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		41: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		41: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"10":"app-components-Workflow-WorkflowContainer","11":"app-components-bibs-BibPage-BibPageContainer","12":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","13":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","14":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","15":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","16":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","17":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","18":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","19":"app-components-bibs-subpages-CommentPage-CommentPageContainer","20":"app-components-bibs-subpages-MarcPage-MarcPageContainer","21":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","22":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","23":"app-components-bibs-subpages-VideoPage-VideoPageContainer","24":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","25":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","26":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","27":"app-components-borrowing-fines-Fines-FinesContainer","28":"app-components-borrowing-holds-Holds-HoldsContainer","29":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","30":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","31":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","32":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","33":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","34":"app-components-events-EventsSearchPage-EventsSearchPageContainer","35":"app-components-search-Search-SearchContainer","36":"app-components-search-SearchPrintList-SearchPrintListContainer","37":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","38":"app-components-shelves-Shelf-ShelfContainer","39":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","40":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"575a6c0f505d6952431b","1":"abeebb917ffbb16df953","2":"2cc662a4cd3106b9f50a","3":"7167258ebb4a1d415c58","4":"509f55fe330d24a6e8b7","5":"9946f9dc32f225f3c9eb","6":"5b37b32769db54bba54d","7":"65e73c8db49298e6d9bd","8":"9549688935676a5ccc08","9":"438c585ecd0a132bc3e0","10":"60ede34284d281a1f8dd","11":"3880ebdb86874d109932","12":"d54de3aee40387acdcf1","13":"7a5fe2f16f023b06c226","14":"4081511d9f1d2c74d6e4","15":"bb3514856a4e7de3b5eb","16":"4c59789ce7c2fab1765b","17":"6511794da4c1357c16ed","18":"61d1404dcbe1f9b6de61","19":"be540b66cb102a44f159","20":"800ffb574fa2f75777db","21":"819f4e29a35dcdb491cb","22":"adae633f93e90c7bb439","23":"cdbe796cbd923aba3130","24":"3edd9ca7f50add0856c6","25":"8decd750f6acf1601acd","26":"9b64c9dc456595b7e09c","27":"e754ab453c8f50070ab5","28":"c0fcf6cab290497f0924","29":"fa4fd70558aeaf9935a1","30":"02bde207f91eaa17f153","31":"d143c1b775f971f7bcc4","32":"f4e7382830c3f3c2d581","33":"3f16c7b6c1b1fd13a59b","34":"c677ed5ca72bf98059a0","35":"97222eee2ff8dc26d9e2","36":"53229a6cc85fd031f0c5","37":"8824fa0514e96cec1963","38":"7d4a168d00f5c3d891ef","39":"3f9246214a3bebef3122","40":"647145d468af4f8abf09","42":"5ee409c086dd8f38403b","43":"11700ef7edc9b25ce4f3","44":"2e9949e60b9274034546","45":"6dcc55b60639e251357a","46":"3b0025db696fed10b1e7","47":"fdda979ed310aa716e80","48":"fa2fa9e1a4aef58e630d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"10":"app-components-Workflow-WorkflowContainer","11":"app-components-bibs-BibPage-BibPageContainer","12":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","13":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","14":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","15":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","16":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","17":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","18":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","19":"app-components-bibs-subpages-CommentPage-CommentPageContainer","20":"app-components-bibs-subpages-MarcPage-MarcPageContainer","21":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","22":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","23":"app-components-bibs-subpages-VideoPage-VideoPageContainer","24":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","25":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","26":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","27":"app-components-borrowing-fines-Fines-FinesContainer","28":"app-components-borrowing-holds-Holds-HoldsContainer","29":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","30":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","31":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","32":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","33":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","34":"app-components-events-EventsSearchPage-EventsSearchPageContainer","35":"app-components-search-Search-SearchContainer","36":"app-components-search-SearchPrintList-SearchPrintListContainer","37":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","38":"app-components-shelves-Shelf-ShelfContainer","39":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","40":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"575a6c0f505d6952431b","1":"abeebb917ffbb16df953","2":"2cc662a4cd3106b9f50a","3":"7167258ebb4a1d415c58","4":"509f55fe330d24a6e8b7","5":"9946f9dc32f225f3c9eb","6":"5b37b32769db54bba54d","7":"65e73c8db49298e6d9bd","8":"9549688935676a5ccc08","9":"438c585ecd0a132bc3e0","10":"60ede34284d281a1f8dd","11":"3880ebdb86874d109932","12":"d54de3aee40387acdcf1","13":"7a5fe2f16f023b06c226","14":"4081511d9f1d2c74d6e4","15":"bb3514856a4e7de3b5eb","16":"4c59789ce7c2fab1765b","17":"6511794da4c1357c16ed","18":"61d1404dcbe1f9b6de61","19":"be540b66cb102a44f159","20":"800ffb574fa2f75777db","21":"819f4e29a35dcdb491cb","22":"adae633f93e90c7bb439","23":"cdbe796cbd923aba3130","24":"3edd9ca7f50add0856c6","25":"8decd750f6acf1601acd","26":"9b64c9dc456595b7e09c","27":"e754ab453c8f50070ab5","28":"c0fcf6cab290497f0924","29":"fa4fd70558aeaf9935a1","30":"02bde207f91eaa17f153","31":"d143c1b775f971f7bcc4","32":"f4e7382830c3f3c2d581","33":"3f16c7b6c1b1fd13a59b","34":"c677ed5ca72bf98059a0","35":"97222eee2ff8dc26d9e2","36":"53229a6cc85fd031f0c5","37":"8824fa0514e96cec1963","38":"7d4a168d00f5c3d891ef","39":"3f9246214a3bebef3122","40":"647145d468af4f8abf09","42":"5ee409c086dd8f38403b","43":"11700ef7edc9b25ce4f3","44":"2e9949e60b9274034546","45":"6dcc55b60639e251357a","46":"3b0025db696fed10b1e7","47":"fdda979ed310aa716e80","48":"fa2fa9e1a4aef58e630d"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2235);
